import { render, staticRenderFns } from "./BillingInformationView.vue?vue&type=template&id=3b97d48f&scoped=true"
import script from "./BillingInformationView.vue?vue&type=script&lang=js"
export * from "./BillingInformationView.vue?vue&type=script&lang=js"
import style0 from "./BillingInformationView.vue?vue&type=style&index=0&id=3b97d48f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b97d48f",
  null
  
)

export default component.exports